/* MOG MINTS, the flip. Scroll across the "What are Mog Mints" section drives 59 frames of the
   mint tumbling and settling into the exact pose the
   formula scroll below splits it from (the last frame IS mintsplit-m_000). Same mechanics as
   mint-scroll.js: frames are preloaded, the nearest decoded frame paints while a flick outruns
   the decoder. The frames are keyed to alpha since 2026-09-14 (floor and reflection removed), so the canvas is transparent. */
(function () {
  var sec = document.getElementById('what'); if (!sec) return;
  var canvas = sec.querySelector('.what__stage canvas'); if (!canvas) return;
  var first = sec.querySelector('.what__card');
  var ctx = canvas.getContext('2d');   /* alpha: the frames are keyed, the ground is the section's */

  var FRAMES = 59;
  /* the mint's centre row in each frame (of 996), from the keyed frames' bounding boxes, smoothed;
     the on-screen path is designed and the canvas is offset per frame to put the mint on it */
  var CY = [671,666,662,652,643,635,626,617,608,600,593,586,580,574,568,563,558,553,550,547,544,542,540,538,536,535,533,532,531,529,528,526,524,521,519,516,514,512,510,508,506,505,504,503,503,503,503,503,503,502,502,502,501,500,500,499,498,498,497];
  var base = window.MOG_FLIP_BASE || '';
  var SRC = function (i) { return base + 'mintflip-h_' + String(i).padStart(3, '0') + '.webp'; };

  var imgs = new Array(FRAMES), ready = new Array(FRAMES), drawn = -1;
  function load(i, cb) {
    if (imgs[i]) return;
    var im = new Image(); im.decoding = 'async';
    im.onload = function () { ready[i] = true; if (cb) cb(); };
    im.src = SRC(i); imgs[i] = im;
  }
  function paint(i) {
    if (i === drawn || !ready[i]) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);   /* the frames carry alpha now */
    ctx.drawImage(imgs[i], 0, 0, canvas.width, canvas.height); drawn = i;
  }
  function nearestReady(i) {
    if (ready[i]) return i;
    for (var d = 1; d < FRAMES; d++) { if (ready[i - d]) return i - d; if (ready[i + d]) return i + d; }
    return -1;
  }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  /* Progress is the section's own scroll: 0 when its top reaches the top of the screen, 1 when
     its bottom reaches the bottom. The flip finishes at 0.85 so the mint rests in the hand-off
     pose for the last stretch and is already still when the formula scroll takes over. */
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* hoisted 2026-09-18. render() used to call matchMedia() itself, which built a fresh
     MediaQueryList on every scroll frame; this is also what the loop below switches on. */
  var mqStack = matchMedia('(max-width: 900px)');
  function render() {
    /* TIMING (Ashot, 2026-09-14): the flip starts when the first benefit card is presented at the
       top of the screen, not when the section's header reaches it, and it lands at the pin: the
       scroll where the formula section's stage takes over on the same pixels (the What section's
       bottom minus one screen). The last frame holds for the final 1.5%. */
    var vh = window.innerHeight;
    var secTop = sec.getBoundingClientRect().top + window.scrollY;
    var s0 = (first ? first.getBoundingClientRect().top + window.scrollY : secTop) - vh * 0.12;
    var s1 = secTop + sec.offsetHeight - vh;
    var p = clamp01(s1 > s0 ? (window.scrollY - s0) / (s1 - s0) : 1);
    /* gone the instant the split's stage pins on the same pixels (p reaches 1 at that scroll);
       after that this stage scrolls out under the formula section and must not be seen leaving */
    canvas.style.visibility = p >= 1 ? 'hidden' : '';
    var q = reduced ? 1 : clamp01(p / 0.985);   /* the last frame holds only for the final 1.5% */
    var f = Math.round(q * (FRAMES - 1));
    var use = nearestReady(f); if (use >= 0) paint(use);
    canvas.dataset.frame = String(f) + ' of ' + FRAMES + ' p=' + p.toFixed(3);   /* read by the harness checks */
    /* THE PATH (Ashot, 2026-09-14): the mint starts high, level with the first card, and travels
       down while it tumbles, landing on the split's pixels. The clip itself has the mint rising, so
       the canvas is offset per frame: designed centre minus where this frame puts the mint. Zero
       at the landing, by construction, so the split's canvas takes over on the same pixels. */
    var vh = window.innerHeight;
    var stage = canvas.parentNode.getBoundingClientRect();
    var top0 = stage.top + canvas.offsetTop;                 /* untransformed canvas top */
    var scale = canvas.offsetHeight / canvas.height;
    var endY = top0 + CY[FRAMES - 1] * scale;                /* where the split's mint sits */
    /* IN LINE WITH THE FIRST CARD (Ashot, 2026-09-14). Until the run begins the mint is locked to
       the first benefit card's centre and scrolls with it, so it arrives beside that card and
       never shows above the heading. The run starts with the card's top at 12% of the viewport
       (s0), and the path descends from the card's centre at that moment to the landing. */
    var fr = first ? first.getBoundingClientRect() : null;
    var drop = vh * 0.05;                                    /* a touch below the card's centre (Ashot) */
    var firstNow = fr ? fr.top + fr.height / 2 + drop : vh * 0.36;
    var startY = fr ? vh * 0.12 + fr.height / 2 + drop : vh * 0.36;
    var e = q * q * (3 - 2 * q);
    var want = p <= 0 ? firstNow : startY + (endY - startY) * e;
    var have = top0 + CY[f] * scale;
    /* ⚠ NO VERTICAL TRAVEL ONCE THE LAYOUT STACKS (2026-09-16). The path above locks the mint to
       the FIRST BENEFIT CARD'S CENTRE, which is right at desktop, where .what__in is two columns
       and the canvas sits in the column beside the cards. At max-width:900px base.css sets
       .what__in{grid-template-columns:1fr} and .what__stage{position:static;order:-1}, so the
       canvas is ABOVE the cards in one column and the card it is chasing is ~450px below it.
       Computed at 390x844: dy came out at +458px before any scroll, and .what declares no
       overflow, so the mint floated over the first two cards for the whole section.
       Stacked, there is no column to travel down, so the frames still tumble in place and the
       canvas stays in its own box. */
    var dy = (reduced || mqStack.matches) ? 0 : want - have;
    canvas.style.transform = 'translateY(' + dy.toFixed(1) + 'px)';
  }

  /* ================= THE PHONE PLAYS, IT DOES NOT SCRUB =================
     Ashot, 2026-09-18: "The animation here should not be scroll derrived, just have the mint
     flip on repeat gently playing with the pace of it in the beginning and end to make it a
     smooth engaging looped video."

     PING-PONG, NOT A REWIND-AND-REPEAT, and that is forced by the artwork rather than chosen.
     Frame 58 is the settled pose the formula scroll splits the mint from; frame 0 is the mint
     high and mid-tumble. Their centres are 174px apart in the source (CY[0] 671 against
     CY[58] 497), so a loop that jumped 58 back to 0 would visibly snap every cycle. Sweeping
     back down the same frames is seamless by construction and reads as the mint turning over
     and settling back, which is the "gently" in the brief.

     SMOOTHSTEP ON EACH SWEEP is the "pace at the beginning and end": t*t*(3-2*t) has zero
     slope at both ends, so every pass eases out of rest and back into it, and the two ends of
     the ping-pong become a pause rather than a bounce. The same easing the path above uses.

     It runs only while the section is on screen, so a phone is not burning a frame budget on
     an animation nobody is looking at, and not at all under reduced motion, where render()
     paints the settled frame once and stops. */
  var SWEEP = 2800;                       /* ms for one pass across the 59 frames */
  var rafId = null, t0 = 0, onScreen = false;

  function loop(ts) {
    rafId = requestAnimationFrame(loop);
    if (!t0) t0 = ts;
    var el = (ts - t0) % (SWEEP * 2);
    var t = el < SWEEP ? el / SWEEP : 2 - el / SWEEP;   /* 0 to 1 and back */
    var e = t * t * (3 - 2 * t);
    var use = nearestReady(Math.round(e * (FRAMES - 1)));
    if (use >= 0) paint(use);
  }

  function startLoop() {
    /* render() hides the canvas past the hand-off and offsets it down its desktop path; the
       loop owns neither, so both are cleared on the way in. */
    canvas.style.visibility = '';
    canvas.style.transform = 'translateY(0px)';
    if (rafId === null) { t0 = 0; rafId = requestAnimationFrame(loop); }
  }
  function stopLoop() { if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; } }

  function looping() { return mqStack.matches && !reduced; }

  function mode() {
    if (looping()) { if (onScreen) startLoop(); else stopLoop(); }
    else { stopLoop(); render(); }
  }

  var ticking = false;
  function onScroll() {
    if (looping()) return;   /* the phone runs on a clock, not on the scroll position */
    if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; render(); }); }
  }
  addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll);

  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; mode(); },
      { rootMargin: '15% 0px' }).observe(sec);
  } else { onScreen = true; }

  if (mqStack.addEventListener) mqStack.addEventListener('change', mode);
  else if (mqStack.addListener) mqStack.addListener(mode);

  /* First frame first, then the last (the hand-off), then everything between.

     ⚠ THE REST GO OUT ON IDLE, NOT IN ONE BURST (2026-09-16). This used to be
     `for (var i = 1; i < FRAMES - 1; i++) load(i, null);` which fired all 57 remaining
     requests in a single tick: 917 KB of WebP, on the home page AND the product page,
     contending with the hero photograph for bandwidth at exactly the moment LCP is measured.
     Four chained workers on requestIdleCallback is the pattern mint-scroll.js already uses
     for its 97 frames, and nobody reaches the scrub before the fill completes.
     load() calls its callback on load and returns early only for a frame already loaded;
     this chain covers 1..FRAMES-2, which the two eager loads above never touch, so it
     cannot stall. */
  load(0, mode); load(FRAMES - 1, mode);

  var next = 1;
  function fill() {
    if (next >= FRAMES - 1) return;
    var i = next++;
    load(i, fill);
  }
  if ('requestIdleCallback' in window) requestIdleCallback(function () { for (var k = 0; k < 4; k++) fill(); });
  else setTimeout(function () { for (var k = 0; k < 4; k++) fill(); }, 200);
})();
